export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8293.bc103dbe.jpg";